import API from "api/API";
import useFetchData from "hooks/useFetchData";

export default function useAZZKULatestEditionID() {
   const { d } = useFetchData({
      APIMethod: API.getAZZKULatestEdition,
      cache_name: "azzku_latest_edition"
   });

   return d?.id;
}